export default class MouseTiltAnimation {
  init() {
    const mouseTiltElements = Array.from(
      document.querySelectorAll('.mouse-tilt-animation-element')
    );

    if (
      !mouseTiltElements.length ||
      window.matchMedia('(hover: none)').matches
    ) {
      return;
    }

    for (let element of mouseTiltElements) {
      const strength = parseInt(
        element.getAttribute('data-mouse-tilt-strength') || '10'
      );

      element.style.transformOrigin = 'center';
      element.style.transform =
        'perspective(10000px) rotateX(0) rotateY(0) rotateZ(0deg)';
      element.style.backfaceVisibility = 'hidden';
      element.style.transition =
        'transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out';

      element.addEventListener('mouseenter', () => {
        requestAnimationFrame(() => {
          element.style.transition = 'none';
        });
      });

      element.addEventListener('mousemove', (e) => {
        const cardRect = element.getBoundingClientRect();

        const x = e.clientX - cardRect.left;
        const y = e.clientY - cardRect.top;

        const centerX = cardRect.width / 2;
        const centerY = cardRect.height / 2;

        const rotateX = ((y - centerY) / centerY) * strength;
        const rotateY = ((centerX - x) / centerX) * strength;

        element.style.transform = `perspective(10000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) rotateZ(0deg)`;
        element.style.boxShadow = `${-rotateY * (1 + strength / 100)}px ${rotateX * (1 + strength / 100)}px 20px rgba(0, 0, 0, ${strength / 100})`;
      });

      element.addEventListener('mouseleave', () => {
        element.style.transform =
          'perspective(10000px) rotateX(0) rotateY(0) rotateZ(0deg)';
        element.style.boxShadow = '0px 0px 20px rgba(0, 0, 0, 0)';
        element.style.transition =
          'transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out';
      });
    }
  }
}
